export function Paragraph({ children }) {
  return <div className="w-full md:w-3/4 lg:w-1/2 m-auto mb-6">{children}</div>;
}
